import React from 'react';
import { View, SafeAreaView, StyleSheet, ActivityIndicator,TouchableOpacity, TouchableWithoutFeedback  } from 'react-native';
import TestAttempt from './quiz';
// import Timer from '../Timer';
import { selectedAnswers, changeQuestion, markedQuestions,submitTest, dispatchClearHomeInfo, clearTest, getAllTestsInfo } from './../../store/actions';
import { connect } from 'react-redux';
// import { Checkbox } from 'react-native-paper';
import { Text } from "./../../components/UI-Components"
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import './newQuizScreen/quiz.scss';
import { Button } from './../../components';
import { withStyles } from '@material-ui/core/styles';

const GreenCheckbox = withStyles({
    root: {
      color: '#99BAFF',
      '&$checked': {
        color: '#FC7F5F',
      },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);


class Quiz extends React.Component {

    state = {
        checked: false
    }


    isMarked = () => {
        const { testInfo, questionsInfo, activeQuestion } = this.props;
        const id = testInfo?.test?.[activeQuestion]?.id;
        let isChecked = false;
        console.log(testInfo, questionsInfo, activeQuestion);
        questionsInfo?.length && questionsInfo.map(qi => {
            if (qi.id === id) {
                qi.marked ? (isChecked = true) : (isChecked = false)
            }
        })
        return isChecked ? true : false;
    }


    render() {
        const { checked } = this.state;
        // console.log(this.isMarked())
        const { selectedAnswers,
            changeQuestion,
            submitTestResponse,
            submitTestLoading,
             testInfo, loading, totalQuestion, activeQuestion, markedQuestions, questionsInfo, totalQuestions } = this.props;
        // console.log(this.props, 'quiz', testInfo, testInfo.testInfo);
        return (
            <>
         
               <div className='col-12 question-compo my-4'>
                    <div className=' question_index mt-2'>
                        <div>
                            <h6>{`Question ${activeQuestion + 1}/ ${testInfo?.test?.length}`}</h6>
                        </div>
                        <div className='mr-2 d-flex flex-row align-items-center'>
                        <TouchableWithoutFeedback  
                           onPress={() => {
                            const id = testInfo?.test[activeQuestion].id; 
                            markedQuestions(id);
                        }}
                           >
                           <View style={[styles.flexRow, { justifyContent: 'flex-end',}]}>
                            
                            <FormControlLabel
                              control={
                                <GreenCheckbox
                                  checked={this.isMarked()}
                                  name="checked"
                                  color="primary"                                  
                                />
                              }                            
                              
                            />
                            <h6 style={{marginLeft: -10}}>Mark Question</h6>
                                </View>
                           </TouchableWithoutFeedback >
                        </div>
                    </div>
                    <div>
                     <TestAttempt data={testInfo?.test} />
                    </div>
                </div>
                 <div className='bottom_compo'>
              {
                !(activeQuestion <= 0) ?
                  <Button
                    width={200}
                    height={50}
                    bgColor={'#fff'}
                    bdColor={'#FF7954'}
                    title={'Previous'}
                    textStyle={{ color: '#FF7954', fontWeight: '700', fontSize: 18 }}
                    onClick={() => changeQuestion(activeQuestion - 1)}

                  />
                  :<View></View>
              
              }

              {
                !(activeQuestion >= totalQuestions - 1) ?

                  <Button
                    width={200}
                    height={50}
                    bgColor={'#fff'}
                    bdColor={'#FF7954'}
                    title={'Next'}
                    textStyle={{ color: '#FF7954', fontWeight: '700', fontSize: 18 }}
                    onClick={() => changeQuestion(activeQuestion + 1)}
                  />
                  :
                  <View></View>
                  
              }
            
            </div>
                {/* <View style={{flex:1}}>
                    <View style={styles.flexRowBetween}>
                        <View style={{marginLeft:15}}>
                            <Text style={styles.flexRow}>
                                <Text style={{fontWeight:'700',color:'#222',fontSize:12}}>{activeQustion + 1}</Text> of <Text style={{fontWeight:'700',color:'#222',fontSize:12}}>{totalQuestion}</Text> Questions
                            </Text>
                        </View>
                        
                           <TouchableOpacity 
                           onPress={() => {
                            const id = testInfo.test[activeQustion].id; 
                            markedQuestions(id);
                        }}
                           >
                           <View style={[styles.flexRow, { justifyContent: 'flex-end',marginRight:10 }]}>
                           
                                <Text style={{paddingRight:2,fontWeight:'400',fontSize:12}}>Mark Question</Text>
                             
                                     <FormControlLabel
                              control={
                                <Checkbox
                                  checked={this.isMarked()}
                                  name="checked"
                                  color="primary"
                                />
                              }
                              
                            />
                                 </View>
                           </TouchableOpacity>
                       
                    </View>

                    <TestAttempt data={testInfo.test} />
                </View> */}
            </>    
        )
    }
}


const mapStateToProps = state => ({
    testInfo: state.testInfo,
    loading: state.testInfo && state.testInfo.loading,
    activeQuestion: state.testInfo && state.testInfo.activeQuestion,
    totalQuestions: state.testInfo && state.testInfo?.test?.length,
    questionsInfo: state.testInfo && state.testInfo.questionsInfo && state.testInfo.questionsInfo || []
})

const styles = StyleSheet.create({
    flexRow: {
        // flex:1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize:12
    },
    flexRowBetween: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottomWidth:1,
        borderBottomColor:'#ccc',
    }
})

export default connect(mapStateToProps, {selectedAnswers, changeQuestion, markedQuestions,submitTest, dispatchClearHomeInfo, clearTest, getAllTestsInfo })(Quiz);

